// src/components/PrivacyPolicy.js
import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          プライバシーポリシー
        </h1>

        <section className="mb-8">
          <p className="mb-4 text-gray-700">
            本サイトは、個人情報の保護を重視し、以下の方針で管理・運営を行います。
            当サイトは個人情報保護法その他関連する法令・ガイドラインを順守します。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            収集する情報
          </h3>
          <p className="mb-4 text-gray-700">
            本サイトでは、サービス提供のために氏名・メールアドレス・クレジットカード情報等を収集する場合があります。
            また、アクセス解析のためにクッキーやIPアドレスなどのログ情報を収集する場合があります。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            情報の利用目的
          </h3>
          <p className="mb-4 text-gray-700">
            収集した情報は、サービス提供・問い合わせ対応・決済処理の目的にのみ使用します。
            また、アクセス解析により得られたデータは、サイトの利便性向上や問題解決のために活用されます。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            情報の保管・管理
          </h3>
          <p className="mb-4 text-gray-700">
            収集された情報は、適切な技術的および組織的対策を講じ、第三者による不正アクセス・漏洩・紛失を防止します。
            個人情報は法令に基づく保存期間を超えて保持されず、クレジットカード情報は決済代行業者（Stripe）により安全に管理されます。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            第三者提供
          </h3>
          <p className="mb-4 text-gray-700">
            取得した情報は、法令に基づく場合を除き、第三者へ提供しません。
            万が一、業務委託等で個人情報を外部に預託する場合には、委託先との間で機密保持契約を締結するなど適切な措置を講じます。
          </p>
        </section>

        <p className="mb-0 text-sm text-gray-500">
          ※ 個人情報の開示・訂正・削除をご希望の場合は、下記「お問い合わせ」までご連絡ください。
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
